import { createSvgIcon } from '@mui/material';

const LockIcon = (props) => {
  const IconCmp = createSvgIcon(
    <>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6 8C6 4.68629 8.68629 2 12 2C15.3137 2 18 4.68629 18 8V9.15032C18.2826 9.21225 18.5539 9.30243 18.816 9.43598C19.5686 9.81947 20.1805 10.4314 20.564 11.184C20.8113 11.6694 20.9099 12.1861 20.9558 12.7482C21 13.2894 21 13.9537 21 14.7587V16.2413C21 17.0463 21 17.7106 20.9558 18.2518C20.9099 18.8139 20.8113 19.3306 20.564 19.816C20.1805 20.5686 19.5686 21.1805 18.816 21.564C18.3306 21.8113 17.8139 21.9099 17.2518 21.9558C16.7106 22 16.0463 22 15.2413 22H8.75873C7.95375 22 7.28938 22 6.74818 21.9558C6.18608 21.9099 5.66938 21.8113 5.18404 21.564C4.43139 21.1805 3.81947 20.5686 3.43598 19.816C3.18868 19.3306 3.09012 18.8139 3.0442 18.2518C2.99998 17.7106 2.99999 17.0463 3 16.2413V14.7587C2.99999 13.9537 2.99998 13.2894 3.0442 12.7482C3.09012 12.1861 3.18868 11.6694 3.43598 11.184C3.81947 10.4314 4.43139 9.81947 5.18404 9.43598C5.44614 9.30243 5.71739 9.21226 6 9.15032V8ZM16 8V9.00163H8V8C8 5.79086 9.79086 4 12 4C14.2091 4 16 5.79086 16 8ZM13 14.5C13 13.9477 12.5523 13.5 12 13.5C11.4477 13.5 11 13.9477 11 14.5V16.5C11 17.0523 11.4477 17.5 12 17.5C12.5523 17.5 13 17.0523 13 16.5V14.5Z"
        fill="currentColor"
      />
    </>,
    'LockIcon',
  );
  return <IconCmp style={{ fill: 'none' }} viewBox={'0 0 24 24'} {...props} />;
};
export default LockIcon;
